import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCustomerSales, getCustomerSalesInstallment } from '../services/sales';

const SalesContext = createContext();

export const SalesProvider = ({ children }) => {
  const [salesData, setSalesData] = useState([]);
  const [currentSale, setCurrentSale] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSaleDetails = async (propertyId) => {
    setLoading(true);
    try {
      const response = await getCustomerSales();
      
      if (response) {
        // Find the current sale based on propertyId
        const propertyDetails = response.find(
          sale => sale.propertyData.propertyId === propertyId
        );

        setCurrentSale(propertyDetails);
        setSalesData(response);

        // Fetch installment data if sale exists
        if (propertyDetails?.customerSalesId) {
          const installmentResponse = await getCustomerSalesInstallment({ customerSalesId: propertyDetails.customerSalesId });
          
          const currentSaleInstallments = installmentResponse.filter(
            installment => installment.customerSales.customerSalesId === propertyDetails.customerSalesId
          );
          
          setPayments(currentSaleInstallments);
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const clearCurrentSale = () => {
    setCurrentSale(null);
    setPayments([]);
  };

  return (
    <SalesContext.Provider 
      value={{
        salesData,
        currentSale,
        payments,
        loading,
        error,
        fetchSaleDetails,
        clearCurrentSale
      }}
    >
      {children}
    </SalesContext.Provider>
  );
};

export const useSales = () => {
  const context = useContext(SalesContext);
  if (!context) {
    throw new Error('useSales must be used within a SalesProvider');
  }
  return context;
};